import { Link } from 'react-router';
import { Empty } from '@reikraft/ui';

export function NotFoundPage() {
  return (
    <Empty>
      Страница не найдена.{' '}
      <Link to="/orders" className="rk-accent">
        К заказам →
      </Link>
    </Empty>
  );
}
